<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';

    export let id = '';
    export let field = '';
    export let value;
    export let top = false

    let results = [];
    let listIndex = -1;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeydown = (event) => {
        if (results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                value = results[listIndex];
                closeDropdown();
            } else if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                closeDropdown();
            }
        } else {
            if (event.key === 'Enter') {
                load();
            }
        }
    }

    const onSelect = (item) => {
        value = item;
        closeDropdown();
    }

    const closeDropdown = () => {
        results = [];
        listIndex = -1;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const load = () => {

        const onSuccess = result => {
            let addEscapeListener = results.length == 0;
            results = result;
            if (results.length && addEscapeListener) {
                document.addEventListener('keydown', handleEscapeKey);
            }
        };

        const onFailure = err => {
        };

        let data = {
            field,
            value
        }

        R.handle(R.analyses.fieldValues, data, onSuccess, onFailure, LOADER.NONE);
    };
</script>
<div class="dropdown-container">
    <input type="text" class="form-control" id="{ id }" bind:value="{ value }" on:keydown={ onKeydown }>
    {#if results.length}
        <div class="dropdown values-dropdown" class:top={ top } use:clickOutside on:click_outside="{ closeDropdown }">
            {#each results as item, index}
                <li class="dropdown-item pointer" class:selected="{ listIndex === index }"
                    on:click={ () => onSelect(item) }>
                    { item }
                </li>
            {/each}
        </div>
    {/if}
</div>

<style>
    .values-dropdown {
        left: 0;
        min-width: unset;
        max-height: 340px;
        overflow-y: auto;
    }

    .values-dropdown.top {
        top: -340px;
    }

    .values-dropdown .dropdown-item {
        padding: 5px 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
    }

</style>